// @flow

import PageContainer from 'insight/pages/common/PageContainer';
import ManagerDataGrid from 'insight/components/datagrid/manager/ManagerDataGrid';
import { APPLICATION_PAGE } from 'insight/constants/GlobalConstants';
import { useLocation } from 'react-router';
import PageTitle from '../../../common/components/PageTitle';

const ManagerTenants = (): React$Node => {
  const location = useLocation();
  const preFilteredTenantId = location?.state?.id;

  return (
    <PageContainer>
      <PageTitle titleKey={'app.page.title.manager.tenants'} />
      <ManagerDataGrid dataGridPage={APPLICATION_PAGE.MANAGER_TENANTS} preFilteredTenantId={preFilteredTenantId} />
    </PageContainer>
  );
};

export default ManagerTenants;
